// hooks/useDonutData.js

import { getValueFromRawData, scaleNumber } from "../utils/utils";

/**
 * Processes raw API data into a format suitable for a DonutChart.
 *
 * @param {Object} rawData - The raw API response data.
 * @param {string} energySource - The energy source like pv (solarpower), wp (windpoer).
 * @param {string} category - The category for which asses should be analyzed, e.g., 'Openspace', 'Power_0_10').
 * @param {string} donutSpec - The label used for the highlighted donut chart segment.
 * @returns {{
 *   data: {
 *     donutData: Array<{ name: string, value: number }>,
 *     totalPower: number,
 *     numberOfAssets: number
 *   } | null,
 *   loading: boolean,
 *   error: Error | null
 * }} Processed donut chart data and status flags.
 */
export const useDonutData = (rawData, energySource, category, donutSpec) => {
  if (!rawData) return { data: null, loading: true, error: null };

  try {
    const total = getValueFromRawData(rawData, `${energySource.toUpperCase()}_Total_Power`);
    const part = getValueFromRawData(rawData, `${energySource.toUpperCase()}_${category}_Total_Power`);
    const assets = getValueFromRawData(rawData, `${energySource.toUpperCase()}_${category}_Number_Of_Active_Assets`);

    const donutData = [
      /* Ensure that the value "total" is never zero so that a donut is always displayed, even if its empty. */
      { name: `nicht ${donutSpec}`, value: (scaleNumber(total, 1000, 2)===0) ? 0.01 : scaleNumber(total - part, 1000, 2) },
      { name: donutSpec, value: scaleNumber(part, 1000, 2)},
    ];

    return {
      data: {
        donutData,
        totalPower: scaleNumber(part, 1000),
        numberOfAssets: scaleNumber(assets),
      },
      loading: false,
      error: null,
    };
  } catch (err) {
    return { data: null, loading: false, error: err };
  }
};
